var ApexAssociatedProductNew = class extends HTMLElement {
  constructor() {
    super();
    this._delegate = new EventDelegator(this);
    this.dialog = null;
  }
  connectedCallback() {
    this.init();
  }
  disconnectedCallback() {
  }
  init() {
    const more = this.querySelector('.more');
    const items = this.querySelectorAll('.associal-item');
    const headIcon = this.querySelector('.apex-associal-head img')
    if(!items.length) return;
    this.dialog = this.querySelector('.associal-detail-dialog');
    more.addEventListener('click', () => {
      items.forEach((item) => {
        item.style.display = 'flex';
      })
      more.style.display = 'none';
    })
    headIcon.addEventListener('click', (e) => {
      this.dialog.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    })
    this.initDialog();
    this.initModified();
  }
  initDialog() {
    const close = this.dialog.querySelector('.dialog-head img');
    this.dialog.addEventListener('click', (e) => {
      if(e.target === this.dialog) {
        this.hideDialog();
      }
    })
    close.addEventListener('click', () => {
      this.hideDialog();
    })
  }
  hideDialog() {
    this.dialog.style.display = 'none';
    document.body.style.overflow = 'auto';
  }
  initModified() {
    const items = this.querySelectorAll('.associal-item');
    items.forEach((item) => {
      const minus = item.querySelector('.operate .minus');
      const container = item.querySelector('.operate');
      const num = item.querySelector('.operate b');
      const add = item.querySelector('.operate .add');
      container.addEventListener('click', (e) => {
        e.stopPropagation();
      })
      minus.addEventListener('click', () => {
        if(num.innerHTML == 0) return;
        num.innerHTML = parseInt(num.innerHTML) - 1;
        if(num.innerHTML == 0) {
          item.classList.remove('checked')
          minus.classList.add('disabled')
          return
        }
      })
      add.addEventListener('click', () => {
        num.innerHTML = parseInt(num.innerHTML) + 1;
        if(!item.classList.contains('checked')) {
          item.classList.add('checked')
        }
        minus.classList.remove('disabled')
      })
      item.addEventListener('click', () => {
        item.classList.toggle('checked')
        if(item.classList.contains('checked')) {
          if(num.innerHTML == 0) {
            num.innerHTML = 1
            minus.classList.remove('disabled')
          }
        } else {
          num.innerHTML = 0
          minus.classList.add('disabled')
        }
      })
    });
  }
};
if (!window.customElements.get("apex-associal-new")) {
  window.customElements.define("apex-associal-new", ApexAssociatedProductNew);
}
